import React, { useEffect } from "react";
import PropTypes from "prop-types";

const config = {
  leaderboard: {
    nitro: {
      floor: 0.25,
      refreshLimit: 10,
      refreshTime: 30,
      refreshVisibleOnly: true,
      renderVisibleOnly: true,
      report: {
        enabled: true,
        position: "bottom-right",
        wording: "Report Ad",
      },
      sizes: [
        ["970", "250"],
        ["300", "250"],
      ],
    },
  },
  leaderboard_a: {
    nitro: {
      acceptable: true,
      floor: 0.25,
      renderVisibleOnly: false,
      report: {
        enabled: true,
        position: "bottom-right",
        wording: "Report Ad",
      },
      sizes: [
        ["970", "250"],
        ["300", "250"],
      ],
    },
  },
  mobile: {
    nitro: {
      anchor: "bottom",
      floor: 0.25,
      format: "anchor",
      mediaQuery: "(min-width: 320px) and (max-width: 767px)",
      refreshLimit: 10,
      refreshTime: 30,
      report: {
        enabled: true,
        position: "fixed-top-left",
        wording: "Report Ad",
      },
      sizes: [["320", "50"]],
    },
  },
  mobile_a: {
    nitro: {
      anchor: "bottom",
      floor: 0.25,
      format: "anchor",
      mediaQuery: "(min-width: 320px) and (max-width: 767px)",
      refreshLimit: 10,
      refreshTime: 30,
      report: {
        enabled: true,
        position: "fixed-top-left",
        wording: "Report Ad",
      },
      sizes: [["320", "50"]],
    },
  },
  right: {
    nitro: {
      floor: 0.25,
      format: "sticky-stack",
      mediaQuery: "(min-width: 1060px)",
      refreshLimit: 10,
      refreshTime: 30,
      refreshVisibleOnly: true,
      renderVisibleOnly: false,
      report: {
        enabled: true,
        position: "bottom-right",
        wording: "Report Ad",
      },
      sizes: [
        ["300", "600"],
        ["300", "250"],
      ],
      stickyStackLimit: 15,
      stickyStackOffset: 78,
      stickyStackSpace: 2.5,
    },
    reloadOnPageChange: true,
  },
  right_a: {
    nitro: {
      acceptable: true,
      floor: 0.25,
      format: "sticky-stack",
      mediaQuery: "(min-width: 1060px)",
      report: {
        enabled: true,
        position: "bottom-right",
        wording: "Report Ad",
      },
      sizes: [
        ["300", "600"],
        ["300", "250"],
      ],
      stickyStackLimit: 15,
      stickyStackOffset: 25,
      stickyStackSpace: 2.5,
    },
    reloadOnPageChange: true,
  },
  video: {
    nitro: {
      format: "video-ac",
    },
  },
};

const Ad = ({ className, id }) => {
  const createAd = (id) => {
    if (window?.nitroAds && config[id]) {
      const ad = {
        ...config[id].nitro,
        demo: window.location.hostname !== "edhrec.com",
      };
      window.nitroAds.createAd(id, ad);
    }
  };

  useEffect(() => {
    createAd(id);
  }, []);

  return <div className={className} id={id} />;
};

Ad.propTypes = {
  className: PropTypes.string,
  height: PropTypes.number,
  id: PropTypes.string.isRequired,
};

export default Ad;
